import { ABaseModel } from '../abstracts/ABaseModel.js';
import {
  IAnalyticsReport,
  IAnalyticsDimension,
  IAnalyticsMetric,
  IAnalyticsReportRow,
  IAnalyticsReportValue,
} from '../interfaces/Analytics.js';

/**
 * AnalyticsDimension
 */
class AnalyticsDimension extends ABaseModel implements IAnalyticsDimension {
  name: string;
  type: string;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * AnalyticsMetric
 */
class AnalyticsMetric extends ABaseModel implements IAnalyticsMetric {
  name: string;
  type: string;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * AnalyticsReportValue
 */
class AnalyticsReportValue extends ABaseModel implements IAnalyticsReportValue {
  name: string;
  value: string | number | boolean;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * AnalyticsReportRow
 */
class AnalyticsReportRow extends ABaseModel implements IAnalyticsReportRow {
  dimensions: Array<AnalyticsReportValue>;
  metrics: Array<AnalyticsReportValue>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * AnalyticsReport
 */
class AnalyticsReport extends ABaseModel implements IAnalyticsReport {
  dimensions: Array<AnalyticsDimension>;
  metrics: Array<AnalyticsMetric>;
  rows: Array<AnalyticsReportRow>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

export { AnalyticsReport, AnalyticsDimension, AnalyticsMetric, AnalyticsReportRow, AnalyticsReportValue };
